/**
 * Asynchronous entry point
 *
 * This file acts as an async boundary which allows Webpack to asynchronously load
 * any shared modules or remote modules required by Module Federation.
 *
 * {@link https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption }
 */

import("./bootstrap");
